import { createBuilder, createSchema, defineMutatorWithType, defineMutators, defineQueries, } from "@rocicorp/zero";
import { createAppCopyMutators } from "./app-copy-mutators.js";
import { equipmentPlanMutatorDefinitions, equipmentPlanQueryDefinitions, equipmentPlanRelationships, equipmentPlanTables, functionAssignmentRelationships as equipmentFunctionAssignmentRelationships, } from "./equipment-plan.js";
import { projectMutatorDefinitions, projectQueryDefinitions, projectRelationshipsList, projectTables, } from "./projects.js";
const appTables = [
    ...equipmentPlanTables,
    ...projectTables.filter((table) => !equipmentPlanTables.includes(table)),
];
const equipmentRelationshipsForApp = equipmentPlanRelationships.filter((relationship) => relationship !== equipmentFunctionAssignmentRelationships);
const appRelationships = [
    ...equipmentRelationshipsForApp,
    ...projectRelationshipsList.filter((relationship) => !equipmentRelationshipsForApp.includes(relationship)),
];
export const appSchema = createSchema({
    tables: appTables,
    relationships: appRelationships,
});
export const appZql = createBuilder(appSchema);
const defineAppMutator = defineMutatorWithType();
const appCopyMutators = createAppCopyMutators({
    defineAppMutator,
    appZql,
});
// The app combines query and mutator domains from multiple schemas. Zero's
// registry type collapses these spread dynamic domains into unions, so expose
// a callable tree at this package boundary and keep validation in each domain.
export const appQueries = defineQueries({
    ...equipmentPlanQueryDefinitions,
    ...projectQueryDefinitions,
});
export const appMutators = defineMutators({
    ...equipmentPlanMutatorDefinitions,
    ...projectMutatorDefinitions,
    ...appCopyMutators,
});
